<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="bookingDialog" id="new-booking-dialog">
      <md-dialog-title>Add a Booking</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createBooking)">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <h6>Currency</h6>
              <md-radio v-model="booking.currency" value="gbp">GBP</md-radio>
              <md-radio v-model="booking.currency" value="eur">EUR</md-radio>
              <md-radio v-model="booking.currency" value="usd">USD</md-radio>
            </div>
            <div class="md-layout-item md-size-50">
              <h6>Tour</h6>
              <md-field>
                <label for="tour">Tour</label>
                <md-select v-model="selectedTour" name="tour" id="tour">
                  <md-option
                    v-for="(tour, index) in tours"
                    :key="tour.id"
                    :value="index"
                  >
                    {{ tour.title }}
                  </md-option>
                </md-select>
              </md-field>

              <h6>Departure</h6>
              <md-field v-if="selectedTour != -1">
                <label for="departure">Departure</label>
                <md-select
                  v-model="booking.departure_id"
                  name="departure"
                  id="departure"
                >
                  <md-option
                    v-for="departure in tours[selectedTour].departures"
                    :key="departure.id"
                    :value="departure.id"
                  >
                    {{ departure.start_date }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense"
              >Create</md-button
            >
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import tourApi from "@/services/api/tour";

export default {
  name: "BookingCreateDialog",

  props: ["bookingDialog", "customer"],

  data() {
    return {
      booking: {
        currency: "gbp",
        departure_id: null
      },
      selectedTour: -1,
      tours: []
    };
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    createBooking() {
      this.booking.user_id = this.customer.id;
      bookingApi.createBooking(this.booking).then(response => {
        this.$emit("booking-created", response.data);
      });
    }
  },

  mounted() {
    tourApi.getTours().then(response => {
      this.tours = response.data.tours;
    });
  }
};
</script>
<style lang="scss" scoped>
h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.md-radio {
  margin-top: 0px;
  margin-bottom: 14px;
}

.md-dialog .md-dialog-container {
  max-width: 768px;
  min-width: 768px;
  width: 768px;
}
</style>
